/* globals tv */
import '../lib/freewheel-ad-manager';
import FREEWHEEL_DEFAULTS from './FreewheelDefaults';
import isMobile from 'ismobilejs';
import assign from 'lodash/assign';
import queryString from 'query-string';


class Ads {
    constructor (player = null, config = {}) {
        this.config = this.setConfig(config);
        this.siteSectionID = this.setSiteSectionID(this.config.siteSectionID);
        this.theContext = null;
        this.prerolls = [];
        this.midrolls = [];
        this.postrolls = [];
        this.currentPlayingSlot = null;
        this.currentPlayingSlotType = null;
        this.showPreroll = this.config.preroll;
        this.showMidroll = this.config.midroll;
        this.showPostroll = this.config.postroll;

        this.ASPlayer = player;
        this.asPlayerWrapperID = this.ASPlayer.el().getAttribute('id');

        this.theAdManager = new tv.freewheel.SDK.AdManager();
        this.theAdManager.setNetwork(this.config.networkID);
        this.theAdManager.setServer(this.config.serverURL);
        if (this.config.debug) tv.freewheel.SDK.setLogLevel(tv.freewheel.SDK.LOG_LEVEL_DEBUG);
        else tv.freewheel.SDK.setLogLevel(tv.freewheel.SDK.LOG_LEVEL_QUIET);

        this.configureShortcuts();
    }


    setConfig (config) {
        const qs = queryString.parse(location.search);
        let qsConfig = {};
        if (qs.adServerRootUrl && qs.adServerRootUrl === 'dev') qsConfig.serverURL = '//bea4.v.fwmrm.net/ad/g/1'; // set dev server url if dev flag is set in query string
        return assign({}, FREEWHEEL_DEFAULTS, config, qsConfig);
    }


    setSiteSectionID (ssid) {
        let platform = (isMobile.any ? (isMobile.apple.device ? 'ios' : (isMobile.android.device ? 'android' : 'other')) : 'desktop');
        return window.AS_FW_SSID || ssid || this.config.siteSectionIDPrefix + platform;
    }


    getFreewheelVideoID (videoData) {
        if (!videoData) return FREEWHEEL_DEFAULTS.videoAssetID;
        if (videoData.titleId) {
            return FREEWHEEL_DEFAULTS.fwVideoIDPrefix + videoData.titleId;
        } else {
            return FREEWHEEL_DEFAULTS.fwVideoIDPrefix + videoData.id;
        }
    }


    setContext (videoData, events = {}) {
        var videoAssetID = this.getFreewheelVideoID(videoData);  // gets the freewheel id and sets it as the videoAssetID
        var videoDuration = (videoData.duration) ? videoData.duration : 86400; // gets the duration from the current video and passes it to the FW context

        if (this.theContext) {
            this.theContext.dispose();
            this.theContext = null;
        }

        this.theContext = this.theAdManager.newContext();
        this.theContext.setProfile(this.config.profileID);
        this.theContext.setVideoAsset(videoAssetID, videoDuration, this.config.networkID);
        this.theContext.setSiteSection(this.siteSectionID, this.config.serverURL);

        this.theContext.registerVideoDisplayBase(this.asPlayerWrapperID);

        this.theContext.submitRequest();

        return this.theContext;
    }


    setContextVideoState (state) {
        this.theContext.setVideoState(state);
    }


    setSlots () {
        this.prerolls = [];
        this.midrolls = [];
        this.postrolls = [];

        var fwTemporalSlots = this.theContext.getTemporalSlots();
        for (var i = 0; i < fwTemporalSlots.length; i++) {
            var slot = fwTemporalSlots[i];
            switch (slot.getTimePositionClass()) {
                case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:
                    if (this.showPreroll) this.prerolls.push(slot);
                    break;
                case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:
                // case tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:
                    if (this.showMidroll) this.midrolls.push(slot);
                    break;
                case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:
                    if (this.showPostroll) this.postrolls.push(slot);
                    break;
            }
        }

        // sort midrolls
        this.midrolls.sort(function(x, y) { return x.getTimePosition() > y.getTimePosition(); } );
    }


    getMidroll (currentTime) {
        for (let i = 0; i < this.midrolls.length; i++) {
            const slot = this.midrolls[i];
            const slotTimePosition = slot.getTimePosition();
            let midrollsToRemove = 0;

            if ((currentTime - slotTimePosition >= 0)) {
                // remove all previous midrolls so we don't play them again
                for (let j = 0; j < this.midrolls.length; j++) {
                    if (slotTimePosition > this.midrolls[j].getTimePosition()) {
                        midrollsToRemove++;
                    }
                }
                this.midrolls.splice(0, midrollsToRemove);

                return slot;
            }
        }

        return null;
    }


    startPreroll (slot) {
        slot = (slot) ? slot : this.prerolls[0];

        this.currentPlayingSlot = slot;
        this.currentPlayingSlotType = slot.getTimePositionClass();
        slot.play();
    }


    startMidroll (slot) {
        slot = (slot) ? slot : this.midrolls[0];

        this.currentPlayingSlot = slot;
        this.currentPlayingSlotType = slot.getTimePositionClass();
        slot.play();
    }


    startPostroll (slot) {
        slot = (slot) ? slot : this.postrolls[0];

        this.currentPlayingSlot = slot;
        this.currentPlayingSlotType = slot.getTimePositionClass();
        slot.play();
    }


    configureShortcuts () {
        var isCtrl = false;

        var onKeyDown = (e) => {
            // ctrl+s - skip current ad
            if (e.keyCode == 17) isCtrl = true;
            if (e.keyCode == 83 && isCtrl == true) {
                this.skipAd();
            }
        };

        var onKeyUp = (e) => {
            if (e.keyCode == 17) isCtrl = false;
        };

        document.onkeydown = onKeyDown;
        document.onkeyup = onKeyUp;
    }


    skipAd () {
        if (this.currentPlayingSlot) this.currentPlayingSlot.skipCurrentAd();
    }


    getCurrentSlot () {
        return this.currentPlayingSlot;
    }
}


export default Ads;



// WEBPACK FOOTER //
// ./src/ads/Freewheel.js